import React from 'react';
import { useTranslation } from 'react-i18next';
import st from './styles.module.scss';
import map from '../../../../assets/images//landing/footer/footer-map.svg';
import { FiMail, FiPhone } from 'react-icons/fi';
import { MdAccessTime } from 'react-icons/md';
import logo from '../../../../assets/images/logo/uwed-logo.svg';
import { NavLink } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className={st.footer}>
      <div className="container" style={{ maxWidth: '1130px' }}>
        <div className={`container ${st.footerContent}`}>
          <div className={st.footerInfo}>
            <div className={st.footerLogoContainer}>
              <div className={st.footerLogo}>
                <div className={st.footerLogoBackground}>
                  <img src={logo} alt="logo" style={{ width: '55px', height: '55px' }} />
                </div>
                <p>{t('address_landing')}</p>
              </div>
              <NavLink className={st.privacyPolicyLink} to="/privacy-policy" target="_blank">
                {t('privacyPolicy')}
              </NavLink>
            </div>
            <div className={st.footerContactWrapper}>
              <h3 style={{ fontSize: '20px' }}>{t('contactUs')}</h3>
              <p className={st.footerContact}>
                <FiPhone size={18} />
                <a href="tel:+998712673950">(71) 267 39 50</a>
              </p>
              <p className={st.footerContact}>
                <FiMail size={18} />
                <a href="mailto:i.muratov@uwed.uz">i.muratov@uwed.uz</a>
              </p>
              <p className={st.footerContact}>
                <MdAccessTime size={18} />
                <span
                  style={{
                    color: '#fff',
                    fontSize: '18px',
                  }}
                >
                  09:00 - 18:00
                </span>
              </p>
            </div>
          </div>
          <div className={st.mapMobile}>
            <img
              src={map}
              alt="Footer Map illustration"
              className="img-fluid"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
